<template>
  <div>
    <div>
      <el-button @click="back" type="text" class="backtext"> <i class="iconfont el-icon-arrow-left"></i> 返回</el-button>
    </div>
    <!-- 数电发票 -->
    <div v-if="[3,4].includes(detailData.type) ">
      <div class="invoiceInfo">
        <div class="invoiceinfoDiv">
          <div class="invoiceinfoDivtitle">发票申请信息</div>
        </div>
        <div class="ulListDiv">
          <ul class="ulList">
            <li>
              <div class="label">发票类型</div>
              <div class="value">{{ detailData.typeStr ||'---' }}</div>
            </li>
            <li>
              <div class="label">发票金额</div>
              <div class="value valueamount">￥{{ detailData.amount  | formatMoney}}</div>
            </li>
            <li>
              <div class="label">发票抬头</div>
              <div class="value">{{ detailData.companyName  ||'---'}}</div>
            </li>
            <li>
              <div class="label">电子邮箱</div>
              <div class="value">{{ detailData.email  ||'---'}}</div>
            </li>
          </ul>
        </div>
      </div>

      <div class="invoicesdetailsCard" v-if="detailData.compInvoiceInfos.length>0">
        <div class="invoiceinfoDiv">
          <div class="invoiceinfoDivtitle">发票开票信息</div>
          <div class="infoTitleBtn">
            <el-button type="primary"  v-if="detailData.status==3" :loading="loading" @click="donwload">
              <a :href="`${onlineUrl}/mk-leads/common/attach/download-file/${detailData.attach.hashCode}`">下载发票</a>
            </el-button>
          </div>
        </div>
        <div class="ulListDiv" >
          <ul class="ulList" v-for="(item,index) in detailData.compInvoiceInfos" :key="index">
            <li>
              <div class="label">发票抬头</div>
              <div class="value">{{ detailData.companyName  ||'---'}}</div>
            </li>
            <li>
              <div class="label">发票类型</div>
              <div class="value ">{{ detailData.typeStr  ||'---'}}</div>
            </li>
            <li>
              <div class="label">发票内容</div>
              <div class="value">平台服务费</div>
            </li>
            <li>
              <div class="label">税率</div>
              <div class="value">{{ detailData.taxRate||'---'}}</div>
            </li>
            <li>
              <div class="label">开票金额</div>
              <div class="value valueamount">￥{{ item.amount| formatMoney}}</div>
            </li>
            <li>
              <div class="label">发票号码</div>
              <div class="value">{{ item.invoiceNum||'---'}}</div>
            </li>
            <li>
              <div class="label">发票凭证</div>
              <div class="value filestyle">
                <uploadListLineView
                  v-if="uploadList.length "
                  :uploadFileList="uploadList"
                  :buyerUserInfoVo="{}"
                  style="margin-top: 5px;"
                  :isWm="false"
                  />  
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 纸质发票 -->
    <div v-if="[1,2].includes(detailData.type) ">
      <div class="invoiceInfo">
        <div class="invoiceinfoDiv">
          <div class="invoiceinfoDivtitle">发票申请信息</div>
          <!-- <div class="infoTitleBtn">
            <el-button type="primary" @click="donwload" v-if="detailData.status==3">下载发票</el-button>
          </div> -->
        </div>
        <div class="ulListDiv">
          <ul class="ulList">
            <li>
              <div class="label">发票类型</div>
              <div class="value">{{ detailData.typeStr  ||'---'}}</div>
            </li>
            <li>
              <div class="label">发票金额</div>
              <div class="value valueamount">￥{{ detailData.amount  | formatMoney }}</div>
            </li>
            <li>
              <div class="label">发票抬头</div>
              <div class="value">{{ detailData.companyName  ||'---'}}</div>
            </li>
            <li>
              <div class="label">纳税人识别号</div>
              <div class="value">{{ detailData.identityCard  ||'---'}}</div>
            </li>
            <li>
              <div class="label">地址和电话</div>
              <div class="value">{{ detailData.addr  ||'---'}} {{ detailData.phone  ||'---'}}</div>
            </li>
            <li>
              <div class="label">开户行和银行账号</div>
              <div class="value">{{ detailData.bank  ||'---'}} {{detailData.bankAccount  ||'---'}}</div>
            </li>
            <li>
              <div class="label">收件人</div>
              <div class="value">{{ detailData.receiverName  ||'---'}}</div>
            </li>
            <li>
              <div class="label">发票邮寄地址和电话</div>
              <div class="value">{{ detailData.receiverAddr  ||'---'}} {{ detailData.receiverPhone  ||'---'}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="PaperulinvoiceInfo" v-if="[3,5].includes(detailData.status)">
        <div class="PaperulinfoTitle">发票开票信息</div>
        <div class="PaperululListDiv" >
          <div class="PaperulListDiv" >
            <ul class="PaperulList PaperulListLeft" v-for="(item,index) in detailData.compInvoiceInfos" :key="index">
              <li>
                <div class="label">开票金额</div>
                <div class="value valueamount">￥{{ item.amount  | formatMoney}}</div>
              </li>
              <li>
                <div class="label">发票代码</div>
                <div class="value">{{item.invoiceCode  ||'---'}}</div>
              </li>
              <li>
                <div class="label">发票号码</div>
                <div class="value">{{item.invoiceNum  ||'---'}}</div>
              </li>
            </ul>
          </div>
          <div class="PaperulListDivBtm">
            <ul class="PaperulList">
              <li>
                <div class="label">快递公司</div>
                <div class="value">{{detailData.freightname  ||'---'}}</div>
              </li>
              <li>
                <div class="label">快递单号</div>
                <div class="value">{{detailData.freightNo  ||'---'}}</div>
              </li>
              <li>
                <div class="label">备注</div>
                <div class="value">{{detailData.remark  ||'---'}}</div>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div class="listTabel">
      <div class="tabelTitle">关联订单/支付单信息</div>
      <detailListTabel :detailData="detailData"></detailListTabel>
    </div>
  </div>
</template>
  <script>
import detailListTabel from "@/components/invoice/detailListTabel.vue";
import {invoiceRecordDetail} from "@/utils/api/invoice"
import { downloadFileFun } from '@/utils/common.js'
import { onlineUrl } from '@/utils/config.js'
import uploadListLineView from "@/components/common/upload/upload_list_line_view.vue";
export default {
  components: {
    detailListTabel,
    uploadListLineView
    },
  data() {
    return {
      detailData:{ },
      onlineUrl:onlineUrl,
      uploadList:[],
      loading:false,
    };
  },
  mounted(){
    this.getInvoiceRecordDetail()
    
  },
  methods: {
    getInvoiceRecordDetail(){
      const parmas={
        id:this.$route.query.id
      }
      invoiceRecordDetail(parmas).then(res=>{
        if(res.rspResult.bizCode==200){
          this.detailData=res.data
          if(this.detailData.attach!=null&&this.detailData.attach!=''){
            this.uploadList=[]
            const tempObj = {
              code: 200, // 上传状态
              hashCode: this.detailData.attach.hashCode,
              isCurrentUpload: false, // 是否是当前上传的
              originalName: this.detailData.attach.originalName, // 列表显示的文件名
              progress: 100, // 进度条
              uid: "", // uid用于辨别文件
              url: this.detailData.attach.url,
            };
            this.uploadList.push(tempObj);
          }
        }else if(res.rspResult.bizCode!=1000){
          this.$message.error(res.rspResult.message)
        }
      })
    },
    back(){
      this.$router.back()
    },
    donwload(){ 
     this.loading=true
     setTimeout(() => {
        this.loading=false
     }, 2000);
    }
  },
};
</script>
  
<style lang="scss" scoped>
.content {
  padding: 20px;
  background: #ffffff;
  margin-top: 10px;
}
.radopGroupDiv {
  border-bottom: 1px solid #e5e8ed;
}
.tips {
  margin-top: 20px;
  background: #f5f7fa;
  padding: 24px 31px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #4f5d78;
}
.invoiceInfo{
  background: #FFFFFF;
  padding: 20px;
  margin-top: 12px;
  .invoiceinfoDiv{
    display: flex;
    margin-bottom: 22px;
    .infoTitleBtn{
      margin-left: auto;
    }
    .invoiceinfoDivtitle{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 16px;
      color: #16181A;
      line-height: 32px;
    }
  }
  .infoTitle{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181A;
    margin-bottom: 30px;
  }
  .ulListDiv{
    border: 1px solid #CFD5DF;
    padding: 24px 31px 5px 31px;
    .ulList{
      li{
        display: flex;
        margin-bottom: 20px;
      }

      .label{
        font-weight: 400;
        font-size: 14px;
        color: #4F5D78;
        width: 180px;
      }
      .value{
        font-weight: 400;
        font-size: 14px;
        color: #16181A;
        // margin-left: 94px;
      }
    }
  }
}
.invoicesdetailsCard{
  background: #FFFFFF;
  padding: 20px;
  margin-top: 12px;
  .invoiceinfoDiv{
    display: flex;
    margin-bottom: 22px;
    .infoTitleBtn{
      margin-left: auto;
    }
    .invoiceinfoDivtitle{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 16px;
      color: #16181A;
      line-height: 32px;
    }
  }
  .infoTitle{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181A;
    margin-bottom: 30px;
  }
  .ulListDiv{
    border: 1px solid #CFD5DF;
    padding: 24px 31px 5px 31px;
    .ulList{
      display: flex;
      flex-wrap: wrap;
      // margin: 0 28px;
      li{
        display: flex;
        width: 50%;
        margin-bottom: 20px;
      }

      .label{
        font-weight: 400;
        font-size: 14px;
        color: #4F5D78;
        width: 180px;
      }
      .value{
        font-weight: 400;
        font-size: 14px;
        color: #16181A;
        // margin-left: 94px;
      }
      .filestyle{
        // padding-top: 5px;
        position: relative;
        top: -4px;
        color: #066EB7;
      }
    }
  }
}
.PaperulinvoiceInfo{
  background: #FFFFFF;
  padding: 20px;
  margin-top: 12px;
  .PaperulinfoTitle{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181A;
    margin-bottom: 30px;
  }
  .PaperululListDiv{
    border: 1px solid #CFD5DF;
    padding: 7px 3px 7px 10px;
    .PaperulListDiv{
      display: flex;
      .PaperulList{
        border: 2px dashed #CFD5DF;
        border-style: 20px 15px 15px 15px space;
        padding: 24px 24px 0 24px ;
        border-radius: 6px;
        width: 50%;
        li{
          display: flex;
          margin-bottom: 20px;
        }

        .label{
          font-weight: 400;
          font-size: 14px;
          color: #4F5D78;
          width: 180px;
        }
        .value{
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          // margin-left: 94px;
        }
      }
      .PaperulListLeft{
        margin-right: 7px;
      }
    }
    .PaperulListDivBtm{
      padding-left: 24px;
      .PaperulList{
        margin-top: 24px;
       
        li{
          display: flex;
          margin-bottom: 20px;
        }

        .label{
          font-weight: 400;
          font-size: 14px;
          color: #4F5D78;
          width: 180px;
        }
        .value{
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          // margin-left: 94px;
        }
      }
    }
  }
}
.listTabel{
  margin-top: 12px;
  background: #FFFFFF;
  padding: 22px 16px;
  .tabelTitle{
    font-weight: 500;
    font-size: 16px;
    color: #16181A;
    margin-bottom: 22px;
    font-family: SourceHanSansCN-Medium;
  }
}
.valueamount{
  color: #FF7F2A !important;
}
.backtext{
  font-weight: 400;
  font-size: 14px;
  color: #4F5D78;
  .el-icon-arrow-left{
    position: relative;
    top: 1px;
  }
}
</style>